import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import _ from 'lodash';

export function AffiliationLanguageRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.AffiliationLanguage', {
		url: '/admin/account/hubs/:id/language',
		controllerAs: 'vm',
		controller: AffiliationLanguageCtrl,
		templateUrl: '/ng/hub/Account/Language/AccountLanguageCtrl.html',
		permission: ['manage_hubs'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/Account/Language/AccountLanguageCtrl.css'),
			$title: () => 'Hub Language',
			languages: ApiResourcify.endpoint('/nosql/languages'),
			oldLanguage: ApiResourcify.endpoint('/clients/:id/language'),
			counts: ApiResourcify.endpoint('/clients/:id/nosql_indices'),
		},
	});
}

export class AffiliationLanguageCtrl {
	constructor($stateParams, $timeout, Api, Pubnub, languages, oldLanguage, counts) {
		'ngInject';
		// save injections
		this.hubId = $stateParams.id;
		this.$timeout = $timeout;
		this.Api = Api;
		this.Pubnub = Pubnub;
		// setup
		this.oldLanguageLabel = oldLanguage.label;
		this.oldLanguageCode = oldLanguage.code;
		this.languages = [{ code: '', label: '(Choose one)' }, ...languages].filter(
			lang => lang.code != this.oldLanguageCode
		);
		this.records = counts;
		this.records.forEach(r => (r.percent = 0));
		this.newLanguageCode = '';
		this.inProgress = false;
	}

	async startConversion() {
		const newLang = _.find(this.languages, { code: this.newLanguageCode });
		this.newLanguageLabel = newLang ? newLang.label : 'Error';
		this.saving = true;
		await this.Api.post('/nosql/imports/yank', {
			hubId: this.hubId,
			language: this.oldLanguageCode,
		});
		await this.Api.post(`/clients/${this.hubId}/language`, { language: this.newLanguageCode });
		this.saving = false;
		this.inProgress = true;
		await this.Api.post('/nosql/imports', { hubId: this.hubId }, { 'Submit-As-Job': 'true' });
		this.listenForConversionProgress();
	}

	listenForConversionProgress() {
		this.Pubnub.getChannel('es-imports').subscribe(payload => {
			console.log('conversion progress!', payload);
			this.$timeout(() => {
				this.records.forEach(record => {
					if (payload.model == record.model) {
						record.percent = Math.round(((payload.done || 0) * 100) / (payload.total || 1));
					}
				});
				if (this.records.every(r => r.percent === 100)) {
					this.allDone = true;
					this.inProgress = false;
				}
			});
		});
	}
}
